<template>
  <v-card elevation="2" outlined class="mx-auto">
    <base-expansion-panel :inputs="shukkaShoruiSakusei.inputs" :reactiveVar="submitData" :key="progress">
      <base-form
        :searchBtn="true"
        :resetBtn="true"
        :inputs="shukkaShoruiSakusei.inputs"
        :reactiveVar="submitData"
        :key="progress"
        @submit-form="apiGetPackingsReadyForShipment(submitData)"
      >
      </base-form>
    </base-expansion-panel>

    <v-card-text>
      <v-row justify="center" align="center" class="mx-0">
        <div v-for="icon in icons" :key="icon" class="mx-2">
          <v-avatar tile rounded :color="icon.color" :size="icon.size">
            <img :src="require(`@/assets/${icon.src}`)" />
          </v-avatar>
          <span> 合計：</span>
          <span
            :class="{
              'red--text text--darken-1':
                limitOverRegionLists[icon.courierName].length > 0 ||
                limitOverCountryLists[icon.courierName].length > 0 ||
                (DailyTotalLimits[icon.courierName].totalWeight > 0 &&
                  icon.totalWeight > DailyTotalLimits[icon.courierName].totalWeight) ||
                (DailyTotalLimits[icon.courierName].totalWeight > 0 &&
                  icon.totalWeight > DailyTotalLimits[icon.courierName].totalWeight) ||
                (DailyTotalLimits[icon.courierName].totalInsurance > 0 &&
                  icon.totalInsurance > DailyTotalLimits[icon.courierName].totalInsurance),
            }"
            >{{ icon.totalWeight.commaString(' kg') }}｜ {{ icon.totalPrice.commaString(' $') }}｜
            {{ icon.totalInsurance.commaString(`${icon.courier !== 1 ? '円' : '$'}`) }}
            <v-tooltip
              v-if="
                limitOverRegionLists[icon.courierName].length > 0 ||
                limitOverCountryLists[icon.courierName].length > 0 ||
                (DailyTotalLimits[icon.courierName].totalWeight > 0 &&
                  icon.totalWeight > DailyTotalLimits[icon.courierName].totalWeight) ||
                (DailyTotalLimits[icon.courierName].totalWeight > 0 &&
                  icon.totalWeight > DailyTotalLimits[icon.courierName].totalWeight) ||
                (DailyTotalLimits[icon.courierName].totalInsurance > 0 &&
                  icon.totalInsurance > DailyTotalLimits[icon.courierName].totalInsurance)
              "
              bottom
              color="red darken-2"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-avatar size="20" v-bind="attrs" v-on="on">
                  <v-icon color="red darken-1"> mdi-alert-circle </v-icon>
                </v-avatar>
              </template>
              <v-list-item-subtitle
                v-if="
                  DailyTotalLimits[icon.courierName].totalWeight > 0 &&
                  icon.totalWeight > DailyTotalLimits[icon.courierName].totalWeight
                "
              >
                {{
                  `- ${icon.name}の1日単位トータル重量制限（${
                    DailyTotalLimits[icon.courierName].totalWeight
                  }kg）を超えてます。`
                }}</v-list-item-subtitle
              >
              <v-list-item-subtitle
                v-if="
                  DailyTotalLimits[icon.courierName].totalPrice > 0 &&
                  icon.totalPrice > DailyTotalLimits[icon.courierName].totalPrice
                "
                >{{
                  `- ${icon.name}の1日単位トータル総額制限（${
                    DailyTotalLimits[icon.courierName].totalPrice
                  }$）を超えてます。`
                }}</v-list-item-subtitle
              >
              <v-list-item-subtitle
                v-if="
                  DailyTotalLimits[icon.courierName].totalInsurance > 0 &&
                  icon.totalInsurance > DailyTotalLimits[icon.courierName].totalInsurance
                "
                >{{
                  `- ${icon.name}の1日単位トータル補償価格制限（${
                    DailyTotalLimits[icon.courierName].totalInsurance
                  }${icon.courier !== 1 ? '円' : '$'}）を超えてます。`
                }}</v-list-item-subtitle
              >
              <v-list-item-subtitle v-if="limitOverRegionLists[icon.courierName].length > 0"
                >- 下記地域総重量、総額、補償価格いずれかの制限に達しています。</v-list-item-subtitle
              >
              <v-list-item-subtitle v-for="region in limitOverRegionLists[icon.courierName]" :key="region">
                <ul>
                  -
                  {{
                    region
                  }}
                </ul>
              </v-list-item-subtitle>
              <v-list-item-subtitle v-if="limitOverCountryLists[icon.courierName].length > 0"
                >- 下記国の総重量、総額、補償価格いずれかの制限に達しています。</v-list-item-subtitle
              >
              <v-list-item-subtitle v-for="country in limitOverCountryLists[icon.courierName]" :key="country">
                <ul>
                  -
                  {{
                    country
                  }}
                </ul>
              </v-list-item-subtitle>
            </v-tooltip>
          </span>
        </div>
      </v-row>
    </v-card-text>
    <v-card-text v-show="hasNoReservationNumber">
      <v-row justify="center" align="center">
        <span class="red--text">{{ messages.HAS_NO_RESERVATION_NUMBER }}</span></v-row
      >
    </v-card-text>
    <base-table
      ref="table"
      item-key="shipping_seq_number"
      :minWidth="2700"
      multi-sort
      show-select
      :hasNoReservationNumber="hasNoReservationNumber"
      :headers="shukkaShoruiSakusei.headers"
      :items="filteredAnkens ?? packingsReadyForShipment"
      :item-class="itemClass"
      :seqWithNoReservationNumber="shippingSeqWithNoReservationNumber"
      :columnName="[
        // Shipping備考確認
        'item.shipping_bikou_flag',
        // Shipping備考
        'item.bikou_list',
        // 重量
        'item.total_weight',
        // Invoice総額
        'item.total_price',
        // 予約番号
        'item.reservation_number',
        // 出荷書類
        'item.shukkaShorui',
        // 印刷
        'item.shukkaShoruiPrint',
        // 書類差し替え
        'item.shoruisashikae',
        // 送付先変更
        'item.soufusaki',
        // ARMS入金あり/なし
        'item.armsNyukinshori',
        // パレット
        'item.pallet_flag',
        // 拠点
        'item.base_name',
        // ダブルチェック者名
        'item.doubleCheck',
        // クーリエAPIに通信
        'item.shukkaDataTsushin',
        // AWBダウンロードリンク
        'item.shipping_label_link',
        // ステータス
        'item.status_name',
        // 運営添付書類
        'item.operator_documents',
        // 主担当
        'item.main_shipping_data_checker',
        //送信結果チェック
        'item.manager_name',
        // CSL照合結果
        'item.csl_matching_result',
        // CSL照合確認
        'item.csl_matching_confirm',
        // CSL照合備考
        'item.csl_matching_memo',
        // 編集
        'item.editing',
      ]"
      @row-selected="rowSelected"
    >
      <template v-slot:[`item.shipping_bikou_flag`]="{ item }">
        <div class="d-flex justify-center align-center">
          <lazy>
            <v-checkbox
              v-if="item.shipping_description && item.editing"
              class="mt-0 pt-0"
              color="primary"
              :input-value="item.shipping_bikou_flag > 0"
              dense
              hide-details
              :key="item.shipping_bikou_flag"
              @change="item.newValue.shipping_bikou_flag = $event ? 1 : 0"
            ></v-checkbox>
            <v-checkbox
              v-else-if="item.shipping_description"
              class="mt-0 pt-0"
              color="primary"
              :input-value="item.shipping_bikou_flag > 0"
              dense
              hide-details
              disabled
            ></v-checkbox>
          </lazy>
        </div>
      </template>
      <template v-slot:[`item.total_weight`]="{ item }">
        <td v-if="item.total_weight != null" class="text-right">
          <div class="d-flex justify-center align-center">
            {{ item.total_weight.commaString(' kg') }}
            <v-tooltip top color="red darken-2">
              <template v-slot:activator="{ on, attrs }">
                <v-avatar
                  v-if="
                    item.total_weight > courierLimits?.[item.country_name]?.[item.courier_name]?.individualWeight &&
                    courierLimits?.[item.country_name]?.[item.courier_name]?.individualWeight > 0
                  "
                  size="20"
                  class="ml-1"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="red darken-1"> mdi-alert-circle </v-icon>
                </v-avatar> </template
              ><span>{{
                `クーリエの総重量制限（${
                  courierLimits?.[item.country_name]?.[item.courier_name]?.individualWeight
                }kg）に達しています`
              }}</span>
            </v-tooltip>
          </div>
        </td>
      </template>
      <template v-slot:[`item.total_price`]="{ item }">
        <td v-if="item.total_price != null">
          <div class="d-flex justify-center align-center">
            {{ item.total_price.commaString('$') }}
            <v-tooltip top color="red darken-2">
              <template v-slot:activator="{ on, attrs }">
                <v-avatar
                  v-if="
                    (item.total_weight > courierLimits?.[item.country_name]?.[item.courier_name]?.individualPrice &&
                      courierLimits?.[item.country_name]?.[item.courier_name]?.individualPrice > 0) ||
                    (item.total_weight >
                      courierLimits?.[item.country_name]?.[item.courier_name]?.individualCompensation &&
                      courierLimits?.[item.country_name]?.[item.courier_name]?.individualCompensation > 0)
                  "
                  size="20"
                  class="ml-1"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="red darken-1"> mdi-alert-circle </v-icon>
                </v-avatar>
              </template>
              <p
                v-if="
                  item.total_weight > courierLimits?.[item.country_name]?.[item.courier_name]?.individualPrice &&
                  courierLimits?.[item.country_name]?.[item.courier_name]?.individualPrice > 0
                "
              >
                {{
                  `クーリエの総額制限（${
                    courierLimits?.[item.country_name]?.[item.courier_name]?.individualPrice
                  }＄）に達しています。`
                }}
              </p>
              <p
                v-if="
                  item.total_weight > courierLimits?.[item.country_name]?.[item.courier_name]?.individualCompensation &&
                  courierLimits?.[item.country_name]?.[item.courier_name]?.individualCompensation > 0
                "
              >
                {{
                  `クーリエの補償制限（${
                    courierLimits?.[item.country_name]?.[item.courier_name]?.individualCompensation
                  }${item.courier != 1 ? '円' : '$'}）に達しています`
                }}
              </p>
            </v-tooltip>
          </div>
        </td>
      </template>

      <template v-slot:[`item.armsNyukinshori`]="{ item }">
        <div class="d-flex justify-center align-center">
          <lazy>
            <v-checkbox
              v-if="item.editing"
              class="mt-0 pt-0"
              color="primary"
              :input-value="item.arms_payment_received_flag > 0"
              dense
              hide-details
              :key="item.armsNyukinshori"
              @change="item.newValue.arms_payment_received_flag = $event ? 1 : 0"
            ></v-checkbox>
            <v-checkbox
              v-else
              class="mt-0 pt-0"
              color="primary"
              :input-value="item.arms_payment_received_flag > 0"
              dense
              hide-details
              disabled
            ></v-checkbox>
          </lazy>
        </div>
      </template>

      <template v-slot:[`item.pallet_flag`]="{ item }">
        <v-icon v-if="item.pallet_flag && item.courier_name != 'UPS'">mdi-check-outline</v-icon>
        <div v-else-if="item.pallet_flag && !item.wwef_sent_flag && item.courier_name == 'UPS'">
          <v-btn x-small color="primary accent-4 white--text" @click="openSendWWEFModal(item)">
            {{ labels.SEND_WWEF }}
          </v-btn>
        </div>
        <div v-else-if="item.pallet_flag && item.wwef_sent_flag && item.courier_name == 'UPS'">
          <v-btn x-small color="red accent-4 white--text" @click="openSendWWEFCancelModal(item)">
            {{ labels.SEND_WWEF_CANCEL }}
          </v-btn>
        </div>
      </template>

      <template v-slot:[`item.base_name`]="{ item }">
        <td style="min-width: 120px; text-align: center">
          <span v-if="item.base_name != null">{{ item.base_name }} </span>
        </td>
      </template>

      <template v-slot:[`item.doubleCheck`]="{ item }">
        <div class="d-flex justify-center align-center">
          <lazy>
            <v-textarea
              v-if="item.editing"
              v-model="item.newValue.double_check"
              auto-grow
              class="pa-0 ma-0"
              :background-color="$vuetify.theme.dark ? 'black' : 'white'"
              dense
              rows="1"
              counter="200"
              :value="item.newValue.double_check"
              style="min-width: 100px"
            ></v-textarea>
            <span v-else>{{ item.double_check }}</span>
          </lazy>
        </div>
      </template>
      <template v-slot:[`item.bikou_list`]="{ item }">
        <v-textarea
          v-if="item.editing"
          v-model="item.newValue.bikou"
          auto-grow
          class="pa-0 ma-0"
          :background-color="$vuetify.theme.dark ? 'black' : 'white'"
          dense
          rows="1"
          hide-details="true"
          :value="item.newValue.bikou"
          style="min-width: 100px"
        ></v-textarea>
        <div v-else-if="item.bikou_list" style="min-width: 100px">
          <span style="line-break: anywhere" v-for="ele in item.bikou_list.split('\n')" :key="ele"
            >{{ ele }}<br
          /></span>
        </div>
      </template>
      <template v-slot:[`item.reservation_number`]="{ item }">
        <span v-if="!item.editing">{{
          item.courier === '1'
            ? `${item.pickup_location_code ?? ''}${item.reservation_number ?? ''}`
            : item.reservation_number
        }}</span>
        <div v-else class="d-flex align-start" style="min-width: 100px">
          <div v-if="item.courier === '1'" class="mr-1" style="max-width: 80px">
            <v-textarea
              v-model="item.newValue.pickup_location_code"
              auto-grow
              class="pa-0 ma-0"
              :background-color="$vuetify.theme.dark ? 'black' : 'white'"
              dense
              rows="1"
              hide-details="true"
              :value="item.newValue.pickup_location_code"
            ></v-textarea>
            <div class="grey--text text--darken-1 reservation-caption">ロケーションコード</div>
          </div>
          <div style="flex: 1">
            <v-textarea
              v-model="item.newValue.reservation_number"
              auto-grow
              class="pa-0 ma-0"
              :background-color="$vuetify.theme.dark ? 'black' : 'white'"
              dense
              rows="1"
              hide-details="true"
              :value="item.newValue.reservation_number"
            ></v-textarea>
            <div v-if="item.courier === '1'" class="grey--text text--darken-1 reservation-caption">予約番号</div>
          </div>
        </div>
      </template>
      <template v-slot:[`item.status_name`]="{ item }">
        <span v-if="!item.editing || item.status === 6">{{ item.status_name }}</span>
        <v-btn v-else x-small color="primary" @click="showDangerStatusChangeConfirmModal(item)">出荷書類作成済み</v-btn>
      </template>
      <template v-slot:[`item.main_shipping_data_checker`]="{ item }">
        <span v-if="!item.editing">{{ item.main_shipping_data_checker }}</span>
        <v-textarea
          v-else
          v-model="item.newValue.main_shipping_data_checker"
          auto-grow
          class="pa-0 ma-0"
          :background-color="$vuetify.theme.dark ? 'black' : 'white'"
          dense
          rows="1"
          hide-details="true"
          :value="item.newValue.main_shipping_data_checker"
          style="min-width: 100px"
        ></v-textarea>
      </template>
      <template v-slot:[`item.shukkaShorui`]="{ item }">
        <lazy>
          <div class="d-flex justify-center align-center">
            <v-btn
              x-small
              color="primary"
              @click="downloadMergedExcels({ format: 'url', shippingSeqNumbers: [item.shipping_seq_number] })"
              >DL</v-btn
            >
            <tool-tip
              v-if="item.no_battery_img_models && item.no_battery_img_models.length > 0"
              :message="item.no_battery_img_models?.join(',<br>')"
              classes="mx-2"
            ></tool-tip>
          </div>
        </lazy>
      </template>
      <template v-slot:[`item.shukkaShoruiPrint`]="{ item }">
        <lazy>
          <v-btn x-small color="primary" @click="downloadPrintExcel({ shippingSeqNumbers: [item.shipping_seq_number] })"
            >印刷</v-btn
          >
        </lazy>
      </template>
      <template v-slot:[`item.shoruisashikae`]="{ item }">
        <lazy>
          <v-btn
            v-if="role"
            x-small
            color="primary"
            @click="
              uploadShipmentDocumentsModal = true;
              uploadingRow = item;
            "
            >UP
          </v-btn>
        </lazy>
      </template>
      <template v-slot:[`item.soufusaki`]="{ item }">
        <lazy>
          <div v-if="role" class="d-flex justify-center align-center">
            <v-btn
              x-small
              color="success"
              @click="
                methodFlag = 1;
                showShipmentModal(item, item.sent_to_courier_ship_api);
              "
              >{{ labels.BTN_CHANGE }}</v-btn
            >

            <v-avatar v-if="item.exists_tmp_changed_ship_to" size="20" class="ml-1">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="red darken-1" v-bind="attrs" v-on="on"> mdi-alert-circle </v-icon>
                </template>
                <span>会員様から送付先の一時変更リクエストがあります</span>
              </v-tooltip>
            </v-avatar>

            <v-avatar
              v-if="item.default_ship_to && item.default_ship_to !== item.ship_to_type"
              size="20"
              class="ml-1"
              tile
              ><v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="red darken-1" v-bind="attrs" v-on="on"> mdi-airplane-alert </v-icon>
                </template>
                <span>送付先が変更されてます</span>
              </v-tooltip>
            </v-avatar>
          </div>
        </lazy>
      </template>
      <template v-slot:[`item.manager_name`]="{ item }">
        <div align="center" justify="center">
          <lazy>
            <v-btn
              v-if="item.sent_to_courier_ship_api === 1"
              x-small
              color="success"
              @click="
                methodFlag = 3;
                info = item;
                sendShippingSeqNumber = item.shipping_seq_number;
                showShipmentCheckModal = true;
              "
              >{{ labels.BTN_CHECK }}</v-btn
            >
          </lazy>
        </div>
        <div align="center" justify="center">
          <div class="manager-name-text" v-if="item.sent_to_courier_ship_api === 1">
            {{ item.shipping_data_checker }}
          </div>
          <span></span>
        </div>
      </template>
      <template v-slot:[`item.shukkaDataTsushin`]="{ item }">
        <lazy>
          <v-btn
            v-if="item.sent_to_courier_ship_api === 0 && role"
            x-small
            dark
            color="red accent-4 white--text"
            @click="
              methodFlag = 2;
              showShipmentModal(item, 1);
            "
            >{{ labels.BTN_EXECUTE }}</v-btn
          >
          <div>
            <v-btn
              v-if="item.sent_to_courier_ship_api === 2 && role && item.total_cartons > 40 && item.courier == 1"
              x-small
              dark
              color="success"
              @click="retreiveShipment(item)"
              >{{ labels.BTN_RETRIEVE }}<v-icon x-small>mdi-sync</v-icon></v-btn
            >
            <v-btn
              v-if="item.sent_to_courier_ship_api == 1 && role"
              x-small
              color="error"
              @click="showCourierCancelConfirmModal(item)"
              >{{ labels.BTN_CANCEL }}</v-btn
            >
            <v-btn v-if="role" plain text x-small color="red darken-1" @click="showHardCancelConfirmModal(item)"
              >{{ labels.BTN_UNDO_SHIP }}<v-icon x-small>mdi-skull-crossbones</v-icon></v-btn
            >
          </div>
        </lazy>
      </template>
      <template v-slot:[`item.shipping_label_link`]="{ item }">
        <lazy>
          <v-btn
            v-if="item.shipping_label_link"
            x-small
            color="primary"
            @click="downloadFile({ key: item.shipping_label_link })"
            >DL</v-btn
          >
        </lazy>
      </template>
      <template v-slot:[`item.operator_documents`]="{ item }">
        <lazy>
          <div v-if="role">
            <v-btn
              x-small
              color="primary"
              @click="
                uploadOperatorDocumentsModal = true;
                uploadingRow = item;
              "
              >UP</v-btn
            >
            <div v-if="!!item.operator_documents" class="text-caption">
              {{
                !item.operator_documents
                  ? ''
                  : item.operator_documents.length > 0
                    ? 'x' + item.operator_documents.length
                    : ''
              }}
            </div>
          </div>
        </lazy>
      </template>
      <template v-slot:[`item.csl_matching_result`]="{ item }">
        <v-icon v-if="item.is_csl_matching_done && !checkHitCslMatching(item)">mdi-check-outline</v-icon>
        <v-tooltip bottom v-if="item.is_csl_matching_done && checkHitCslMatching(item)">
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="red darken-1" dark v-bind="attrs" v-on="on"> mdi-alert-circle </v-icon>
          </template>
          <span>{{ messages.CSL_MATCHING_HIT_DESCRIPTION }}</span>
          <ul>
            <li v-if="item.csl_hit_member_name">
              <span>{{ label.MEMBER_NAME }}</span>
            </li>
            <li v-if="item.csl_hit_account_holder_company_name">
              <span>{{ label.ACCOUNT_HOLDER }}</span>
            </li>
            <li v-if="item.csl_hit_ship_to_company_name">
              <span>{{ label.SHIP_TO_COMPANY_NAME }}</span>
            </li>
            <li v-if="item.csl_hit_ceo_name">
              <span>{{ label.CEO_NAME }}</span>
            </li>
          </ul>
        </v-tooltip>
      </template>
      <template v-slot:[`item.csl_matching_confirm`]="{ item }">
        <div class="d-flex justify-center align-center">
          <v-checkbox
            v-if="item.editing"
            class="mt-0 pt-0"
            color="primary"
            v-model="item.newValue.csl_matching_confirm_flag"
            dense
            hide-details
          ></v-checkbox>
          <v-checkbox
            v-else
            class="mt-0 pt-0"
            color="primary"
            v-model="item.csl_matching_confirm_flag"
            dense
            hide-details
            disabled
          ></v-checkbox>
        </div>
      </template>
      <template v-slot:[`item.csl_matching_memo`]="{ item }">
        <div class="d-flex justify-center align-center">
          <lazy>
            <v-textarea
              v-if="item.editing"
              v-model="item.newValue.csl_matching_memo"
              auto-grow
              class="pa-0 ma-0"
              :background-color="$vuetify.theme.dark ? 'black' : 'white'"
              dense
              rows="1"
              counter="200"
              :value="item.newValue.csl_matching_memo"
              style="min-width: 100px"
              @change="item.newValue.csl_matching_memo = $event.slice(0, 200)"
            ></v-textarea>
            <span v-else>{{ item.csl_matching_memo }}</span>
          </lazy>
        </div>
      </template>
      <template v-slot:[`item.editing`]="{ item }">
        <lazy>
          <div v-if="role">
            <v-btn v-if="item.editing" text icon color="green lighten-2" @click="updatePackingInfo(item)">
              <v-icon large>mdi-content-save</v-icon>
            </v-btn>
            <v-btn v-else text icon color="blue lighten-2" @click="editPacking(item)">
              <v-icon large>mdi-pencil-box</v-icon>
            </v-btn>
            <v-btn v-if="item.editing" text icon color="red lighten-2" @click="editPacking(item)">
              <v-icon>mdi-close-circle</v-icon>
            </v-btn>
          </div>
        </lazy>
      </template>
    </base-table>

    <v-card-actions class="justify-center mb-1 pt-0">
      <v-btn
        v-if="role"
        color="error"
        :disabled="disabled || alreadySentToCourierApi || wwefSentFlag"
        @click="revertShipping"
        >{{ labels.BTN_SHUKKA_SHIJI_KAIJO }}</v-btn
      >
      <v-btn v-if="role" color="success" :disabled="disabled" @click="showReservationModal = true">{{
        labels.BTN_YOYAKUBANGO_IKKI_NYURYOKU
      }}</v-btn>
      <v-btn
        color="info"
        :disabled="disabled"
        @click="
          downloadMergedExcels({
            format: 'url',
            shippingSeqNumbers: selectedShipments.map((row) => row.shipping_seq_number),
          })
        "
        >{{ labels.BTN_IKKI_DOWNLOAD }}</v-btn
      >
      <v-btn color="primary" :disabled="disabled" @click="showReviewModal = true">{{ labels.BTN_PREVIEW }}</v-btn>
      <v-btn
        color="info"
        :disabled="disabled"
        @click="downloadPrintExcel({ shippingSeqNumbers: selectedShipments.map((row) => row.shipping_seq_number) })"
        >一括印刷用Excel DL</v-btn
      >
      <csv-result-dl
        :disabled="packingsReadyForShipment.length === 0"
        item-key="shipping_seq_number"
        :row-selected="selectedShipments"
      ></csv-result-dl>
      <v-btn color="success" :disabled="disabled" @click="showCslMatchingModal = true">{{ label.CSL_MATCHING }}</v-btn>
    </v-card-actions>

    <v-dialog v-model="showReservationModal" max-width="600px">
      <v-card>
        <v-card-title class="pb-0">{{ labels.BTN_YOYAKUBANGO_IKKI_NYURYOKU }}</v-card-title>
        <v-text-field
          class="ma-3"
          v-model="reservationNumber"
          outlined
          dense
          hide-details="true"
          :label="labels.YOYAKU_BANGO"
        ></v-text-field>
        <v-list v-if="shippingSeqWithReservationNumber.length" class="py-0">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle v-html="messages.HAS_RESERVATION_NUMBER"></v-list-item-subtitle>
              <v-list-item-subtitle v-for="seq in shippingSeqWithReservationNumber" :key="seq"
                >• {{ seq }}</v-list-item-subtitle
              >
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-card-actions class="justify-end">
          <v-btn
            v-if="shippingSeqWithReservationNumber.length"
            color="primary"
            outlined
            @click="addReservationNumberWithoutOverwrite"
            >{{ labels.BTN_NOT_OVERWRITE }}</v-btn
          >
          <v-btn
            :color="shippingSeqWithReservationNumber.length ? 'error' : 'primary'"
            outlined
            @click="addReservationNumber"
            >{{ shippingSeqWithReservationNumber.length ? labels.BTN_OVERWRITE : labels.BTN_ADD }}</v-btn
          >
          <v-btn color="warning" text @click="showReservationModal = false">{{ labels.BTN_CANCEL }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showCslMatchingModal" max-width="400px">
      <v-card color="white">
        <v-card-title class="primary text-subtitile-2 white--text py-1">
          <v-icon color="white" large>mdi-magnify</v-icon>
          <span>{{ label.CSL_MATCHING }}</span>
        </v-card-title>
        <v-card-text class="mt-3">{{ messages.CSL_MATCHING_DESCRIPTION }}</v-card-text>
        <v-col class="pl-5">
          <v-checkbox color="primary" :label="label.MEMBER_NAME" v-model="cslMatchingTarget.memberName"></v-checkbox>
          <v-checkbox
            color="primary"
            :label="label.ACCOUNT_HOLDER"
            v-model="cslMatchingTarget.accountHolderCompanyName"
          ></v-checkbox>
          <v-checkbox
            color="primary"
            :label="label.SHIP_TO_COMPANY_NAME"
            v-model="cslMatchingTarget.shipToCompanyName"
          ></v-checkbox>
          <v-checkbox color="primary" :label="label.CEO_NAME" v-model="cslMatchingTarget.ceoName"></v-checkbox>
        </v-col>
        <v-card-actions class="justify-end">
          <v-btn
            color="primary"
            outlined
            @click="cslMatching"
            :disabled="
              (!cslMatchingTarget.memberName &&
                !cslMatchingTarget.accountHolderCompanyName &&
                !cslMatchingTarget.shipToCompanyName &&
                !cslMatchingTarget.ceoName) ||
              intervalId
            "
            >{{ label.MATCHING }}</v-btn
          >
          <v-btn color="warning" text @click="closeCslMatchingModal">{{ labels.BTN_CANCEL }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showCslMatchingHitModal" max-width="450px">
      <v-card color="white">
        <v-card-title class="error text-subtitile-2 white--text py-1">
          <v-icon color="white" large>mdi-close-octagon</v-icon>
          <span>{{ label.CSL_MATCHING_RESULT }}</span>
        </v-card-title>
        <v-card-text class="mt-3">{{ messages.CSL_MATCHING_HIT_DESCRIPTION }}</v-card-text>
        <v-card-list v-for="item in cslMatchingResult" :key="item">
          <div class="mb-5">
            <div
              v-if="
                item.hit_member_name ||
                item.hit_account_holder_company_name ||
                item.hit_ship_to_company_name ||
                item.hit_ceo_name
              "
              class="ml-5"
            >
              {{ label.SHIPPING_SEQ_NUMBER }} : {{ item.shipping_seq_number }}
            </div>
            <div v-if="item.hit_member_name" class="ml-10">{{ label.MEMBER_NAME }} : {{ item.hit_member_name }}</div>
            <div v-if="item.hit_account_holder_company_name" class="ml-10">
              {{ label.ACCOUNT_HOLDER }} : {{ item.hit_account_holder_company_name }}
            </div>
            <div v-if="item.hit_ship_to_company_name" class="ml-10">
              {{ label.SHIP_TO_COMPANY_NAME }} : {{ item.hit_ship_to_company_name }}
            </div>
            <div v-if="item.hit_ceo_name" class="ml-10">{{ label.CEO_NAME }} : {{ item.hit_ceo_name }}</div>
          </div>
        </v-card-list>
        <v-card-actions class="justify-end">
          <v-btn color="primary" outlined @click="closeCslMatchingResultModal">{{ labels.CLOSE }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showCslMatchingNoHitModal" max-width="450px">
      <v-card color="white">
        <v-card-title class="success text-subtitile-2 white--text py-1">
          <v-icon color="white" large>mdi-checkbox-marked-circle-outline</v-icon>
          <span>{{ label.CSL_MATCHING_RESULT }}</span>
        </v-card-title>
        <v-card-text class="mt-3">{{ messages.CSL_MATCHING_NO_HIT_DESCRIPTION }}</v-card-text>
        <v-card-actions class="justify-end">
          <v-btn color="primary" outlined @click="closeCslMatchingResultModal">{{ labels.CLOSE }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ShippingChangeModal
      :parent="$data"
      :show-modal="showDialog"
      :show-confirm="showShipmentConfirmModal"
      :member-info="info"
      :methodFlag="methodFlag"
      @click:confirm="handleConfirm"
      @click:send="handleShipmentConfirm"
      @close="handleClose"
    />
    <ShippingCheckModal
      :show-modal="showShipmentCheckModal"
      :member-info="info"
      :methodFlag="3"
      @click:confirm="handleConfirm"
      @click:send="handleShipmentConfirm"
      @close="handleClose"
    />
    <ShippingDocPreviewModal
      :show-modal="showReviewModal"
      :shipping-seq-numbers="selectedShippingSeqNumbers"
      @close="handleClose"
    />
    <UploadShipmentDocumentsModal :parent="$data" />
    <UploadOperatorDocumentsModal :parent="$data" />
    <DangerConfirmModal
      :show-modal="showCourierCancelModal"
      :message="dangerMessage"
      :confirmText="dangerConfirmText"
      @click:confirm="handleCourierCancel"
      @click:close="handleClose"
    />
    <DangerConfirmModal
      :show-modal="showHardCancelModal"
      :message="dangerMessage"
      :confirmText="dangerConfirmText"
      @click:confirm="handleHardCancel"
      @click:close="handleClose"
    />
    <UpsShipmentModal @click:close="upsShipmentModalClose" />
    <SendWWEFModal :parent="$data" />
    <SendWWEFCancelModal :parent="$data" />
  </v-card>
</template>

<script>
import { executePage, label } from '@/consts.js';
import { mapActions, mapGetters, mapMutations } from 'vuex';
export default {
  components: {
    ShippingChangeModal: () =>
      import(/* webpackChunkName: "ShippingChangeModal" */ '@/components/ui/ShippingChangeModal.vue'),
    ShippingCheckModal: () =>
      import(/* webpackChunkName: "ShippingCheckModal" */ '@/components/ui/ShippingCheckModal.vue'),
    ShippingDocPreviewModal: () =>
      import(/* webpackChunkName: "ShippingDocPreviewModal" */ '@/components/ui/ShippingDocReviewModal.vue'),
    UploadShipmentDocumentsModal: () =>
      import(/* webpackChunkName: "UploadShipmentDocumentsModal" */ '@/components/ui/UploadShipmentDocumentsModal.vue'),
    UploadOperatorDocumentsModal: () =>
      import(/* webpackChunkName: "UploadOperatorDocumentsModal" */ '@/components/ui/UploadOperatorDocumentsModal.vue'),
    SendWWEFModal: () => import(/* webpackChunkName: "SendWWEFModal" */ '@/components/ui/SendWWEFModal.vue'),
    SendWWEFCancelModal: () =>
      import(/* webpackChunkName: "SendWWEFCancelModal" */ '@/components/ui/SendWWEFCancelModal.vue'),
    DangerConfirmModal: () =>
      import(/* webpackChunkName: "DangerConfirmModal" */ '@/components/ui/DangerConfirmModal.vue'),
    lazy: () => import(/* webpackChunkName: "Lazy" */ '@/components/ui/Lazy.vue'),
    ToolTip: () => import(/* webpackChunkName: "toolTip" */ '../components/ui/ToolTip.vue'),
    UpsShipmentModal: () => import(/* webpackChunkName: "UpsShipmentModal" */ '@/components/ui/UpsShipmentModal.vue'),
  },
  name: 'ShukkaShoruiSakusei',
  computed: {
    ...mapGetters({
      clickedConfirm: 'ui/clickedConfirm',
      clickedCancel: 'ui/clickedCancel',
      shukkaShoruiSakusei: 'defined/shukkaShoruiSakusei',
      labels: 'defined/labels',
      statusItems: 'defined/statusItems',
      messages: 'defined/messages',
      /**
       * クーリエ制限マスタ
       */
      list: 'courierLimitMaster/list',
      mode: 'ui/mode',
      packingsReadyForShipment: 'shukkaShoruiSakusei/packingsReadyForShipment',
      commonSearchConditions: 'common/searchConditions',
      shukkayoteiDate: 'shukkaShoruiSakusei/shukkayoteiDate',
      latestAfterTomorrow: 'shukkaShoruiSakusei/latestAfterTomorrow',
      path: 'defined/pathNames',
      user: 'defined/user',
      cslMatchingResult: 'shukkaShoruiSakusei/cslMatchingResult',
      currentBases: 'base/currentBases',
    }),
    label() {
      return label;
    },
    executePage() {
      return executePage;
    },
    hasNoReservationNumber() {
      return this.packingsReadyForShipment.some(
        ({ reservation_number }) => !reservation_number || reservation_number === '',
      );
    },
    shippingSeqWithReservationNumber() {
      return this.selectedShippingSeqNumbers
        .map((x) =>
          this.packingsReadyForShipment
            ?.filter(({ reservation_number, shipping_seq_number }) => shipping_seq_number === x && reservation_number)
            ?.map(({ shipping_seq_number }) => shipping_seq_number),
        )
        .flat(Infinity);
    },
    shippingSeqWithNoReservationNumber() {
      return this.packingsReadyForShipment
        ?.map(({ reservation_number, shipping_seq_number }) =>
          !reservation_number || reservation_number === '' ? shipping_seq_number : null,
        )
        .filter((x) => x);
    },
    searchConditions() {
      return this.commonSearchConditions?.shukkaShoruiSakusei;
    },
    progress() {
      return this.searchConditions?.progress ?? null;
    },
    disabled() {
      return this.selectedShipments.length === 0;
    },
    wwefSentFlag() {
      return this.selectedShipments.find(({ wwef_sent_flag }) => wwef_sent_flag === 1);
    },
    alreadySentToCourierApi() {
      return this.selectedShipments.some(({ sent_to_courier_ship_api }) => sent_to_courier_ship_api === 1);
    },
    selectedShippingSeqNumbers() {
      return this.selectedShipments.map(({ shipping_seq_number }) => shipping_seq_number);
    },
    shippingSeqNumbers() {
      return this.packingsReadyForShipment.map(({ shipping_seq_number }) => shipping_seq_number);
    },
    /**
     * 一日単位のクーリエのトータル重要制限
     * @type {number}
     */
    DailyTotalLimits() {
      return {
        fedex: {
          totalWeight: this.list?.find(({ countryCode }) => countryCode.toLowerCase() === 'fedex')?.totalWeight ?? 0,
          totalPrice: this.list?.find(({ countryCode }) => countryCode.toLowerCase() === 'fedex')?.totalPrice ?? 0,
          totalInsurance:
            this.list?.find(({ countryCode }) => countryCode.toLowerCase() === 'fedex')?.totalCompensation ?? 0,
        },
        ups: {
          totalWeight: this.list?.find(({ countryCode }) => countryCode.toLowerCase() === 'ups')?.totalWeight ?? 0,
          totalPrice: this.list?.find(({ countryCode }) => countryCode.toLowerCase() === 'ups')?.totalPrice ?? 0,
          totalInsurance:
            this.list?.find(({ countryCode }) => countryCode.toLowerCase() === 'ups')?.totalCompensation ?? 0,
        },
        dhl: {
          totalWeight: this.list?.find(({ countryCode }) => countryCode.toLowerCase() === 'dhl')?.totalWeight ?? 0,
          totalPrice: this.list?.find(({ countryCode }) => countryCode.toLowerCase() === 'dhl')?.totalPrice ?? 0,
          totalInsurance:
            this.list?.find(({ countryCode }) => countryCode.toLowerCase() === 'dhl')?.totalCompensation ?? 0,
        },
      };
    },

    /**
     * 表に表示されている出荷分のトータル重量、総額、補償額をクーリエごとに分ける処理
     */
    shipmentTotalsByCourier() {
      return {
        fedex: {
          totalWeight: this.packingsReadyForShipment
            ?.map(({ total_weight, courier }) => (+courier === 1 ? +total_weight : 0))
            ?.reduce((a, b) => a + b, 0),
          totalPrice: this.packingsReadyForShipment
            ?.map(({ total_price, courier }) => (+courier === 1 ? +total_price : 0))
            ?.reduce((a, b) => a + b, 0),
          totalInsurance: this.packingsReadyForShipment
            ?.map(({ insurance_price, courier }) => (+courier === 1 ? +insurance_price : 0))
            ?.reduce((a, b) => a + b, 0),
        },
        ups: {
          totalWeight: this.packingsReadyForShipment
            ?.map(({ total_weight, courier }) => (+courier === 2 ? +total_weight : 0))
            ?.reduce((a, b) => a + b, 0),
          totalPrice: this.packingsReadyForShipment
            ?.map(({ total_price, courier }) => (+courier === 2 ? +total_price : 0))
            ?.reduce((a, b) => a + b, 0),
          totalInsurance: this.packingsReadyForShipment
            ?.map(({ insurance_price, courier }) => (+courier === 2 ? +insurance_price : 0))
            ?.reduce((a, b) => a + b, 0),
        },
        dhl: {
          totalWeight: this.packingsReadyForShipment
            ?.map(({ total_weight, courier }) => (+courier === 3 ? +total_weight : 0))
            ?.reduce((a, b) => a + b, 0),
          totalPrice: this.packingsReadyForShipment
            ?.map(({ total_price, courier }) => (+courier === 3 ? +total_price : 0))
            ?.reduce((a, b) => a + b, 0),
          totalInsurance: this.packingsReadyForShipment
            ?.map(({ insurance_price, courier }) => (+courier === 3 ? +insurance_price : 0))
            ?.reduce((a, b) => a + b, 0),
        },
      };
    },

    /**
     * 表に表示される出荷分トータルを地域毎に分ける処理
     */
    shipmentTotalsByRegion() {
      const totals = { fedex: {}, ups: {}, dhl: {} };
      // 各クーリエに地域プロパティを追加する
      this.packingsReadyForShipment.map(({ region, courier }) => {
        // 99 その他地域
        if (+region !== 99 && courier)
          totals[+courier === 1 ? 'fedex' : +courier === 2 ? 'ups' : +courier === 3 ? 'dhl' : 'others'][region] = {
            totalWeight: 0,
            totalPrice: 0,
            totalInsurance: 0,
          };
      });
      // 各クーリエの地域プロパティにそれぞれのトータルを入れる
      this.packingsReadyForShipment.map(({ total_weight, total_price, insurance_price, region, courier }) => {
        const courierName = +courier === 1 ? 'fedex' : +courier === 2 ? 'ups' : +courier === 3 ? 'dhl' : 'others';
        if (+region !== 99 && courier) {
          totals[courierName][region]['totalWeight'] += +total_weight;
          totals[courierName][region]['totalPrice'] += +total_price;
          totals[courierName][region]['totalInsurance'] += +insurance_price;
        }
      });
      return totals;
    },
    /**
     * 表に表示される出荷分トータルを国毎に分ける処理
     */
    shipmentTotalsByCountries() {
      const totals = { fedex: {}, ups: {}, dhl: {} };
      this.packingsReadyForShipment.map(({ country_name, courier }) => {
        totals[+courier === 1 ? 'fedex' : +courier === 2 ? 'ups' : 'dhl'][country_name] = {
          totalWeight: 0,
          totalPrice: 0,
          totalInsurance: 0,
        };
      });
      this.packingsReadyForShipment.map(({ total_weight, total_price, insurance_price, country_name, courier }) => {
        const courierName = +courier === 1 ? 'fedex' : +courier === 2 ? 'ups' : 'dhl';
        totals[courierName][country_name]['totalWeight'] += +total_weight;
        totals[courierName][country_name]['totalPrice'] += +total_price;
        totals[courierName][country_name]['totalInsurance'] += +insurance_price;
      });
      return totals;
    },

    /**
     * 地域コード
     */
    regionNames() {
      const names = {};
      this.list.forEach(({ region, areaCode }) => {
        if (+areaCode < 100) {
          names[areaCode] = region;
        }
      });
      return names;
    },
    /**
     * 制限を超えた地域を絞り込む処理
     */
    limitOverRegions() {
      const fedex = {};
      const ups = {};
      const dhl = {};
      const overRegionLimit = (region = '', shipment = {}, courierId = 1) => {
        const { totalWeight, totalPrice, totalCompensation } = this.courierLimitsByRegion(region, courierId);
        return +totalWeight > 0 || +totalPrice > 0 || +totalCompensation > 0
          ? (+totalWeight > 0 ? shipment.totalWeight > totalWeight : false) ||
              (+totalPrice > 0 ? shipment.totalPrice > totalPrice : false) ||
              (+totalCompensation > 0 ? shipment.totalInsurance > totalCompensation : false)
          : false;
      };
      for (const [courier, courierData] of Object.entries({ fedex, ups, dhl })) {
        for (const [region, shipment] of Object.entries(this.shipmentTotalsByRegion[courier])) {
          if (overRegionLimit(region, shipment, courier === 'fedex' ? 1 : courier === 'ups' ? 2 : 3))
            courierData[region] = true;
        }
      }
      return { fedex: fedex, ups: ups, dhl: dhl };
    },
    /**
     * 制限を超えた国を絞り込む処理
     */
    limitOverCountries() {
      const fedex = {};
      const ups = {};
      const dhl = {};
      const overCountryLimit = (countryName = '', shipment = {}, courierId = 1) => {
        const { totalWeight, totalPrice, totalCompensation } = this.courierLimitsByCountries(countryName, courierId);
        return +totalWeight > 0 || +totalPrice > 0 || +totalCompensation > 0
          ? (+totalWeight > 0 ? shipment.totalWeight > totalWeight : false) ||
              (+totalPrice ? shipment.totalPrice > totalPrice : false) ||
              (+totalCompensation > 0 ? shipment.totalInsurance > totalCompensation : false)
          : false;
      };
      for (const [courier, courierData] of Object.entries({ fedex, ups, dhl })) {
        for (const [countryName, shipment] of Object.entries(this.shipmentTotalsByCountries[courier])) {
          if (overCountryLimit(countryName, shipment, courier === 'fedex' ? 1 : courier === 'ups' ? 2 : 3))
            courierData[countryName] = true;
        }
      }
      return { fedex: fedex, ups: ups, dhl: dhl };
    },

    /**
     * 制限を超えている地域のリスト
     * - アラートの下にリストとして表示される
     */
    limitOverRegionLists() {
      const fedex = [];
      const ups = [];
      const dhl = [];
      for (const [courier, courierData] of Object.entries({ fedex, ups, dhl })) {
        for (const regionCode in this.limitOverRegions[courier]) {
          if (this.limitOverRegions[courier][regionCode]) {
            courierData.push(this.regionNames[regionCode]);
          }
        }
      }
      return { fedex, ups, dhl };
    },
    /**
     * 制限を超えている国のリスト
     * - アラートの下にリストとして表示される
     */
    limitOverCountryLists() {
      return {
        fedex: Object.keys(this.limitOverCountries['fedex']),
        ups: Object.keys(this.limitOverCountries['ups']),
        dhl: Object.keys(this.limitOverCountries['dhl']),
      };
    },

    /**
     * クーリエ単位の制限
     */
    courierLimits() {
      const limits = {};
      this.list?.map(({ countryName }) => (limits[countryName] = { FEDEX: {}, UPS: {}, DHL: {} }));

      this.list.map(
        ({
          countryName,
          courierId,
          totalWeight,
          totalPrice,
          totalCompensation,
          individualWeight,
          individualPrice,
          individualCompensation,
        }) => {
          if (+courierId === 1) {
            limits[countryName]['FEDEX'] = {
              totalWeight,
              totalPrice,
              totalCompensation,
              individualWeight,
              individualPrice,
              individualCompensation,
            };
          } else if (+courierId === 2) {
            limits[countryName]['UPS'] = {
              totalWeight,
              totalPrice,
              totalCompensation,
              individualWeight,
              individualPrice,
              individualCompensation,
            };
          } else if (+courierId === 3) {
            limits[countryName]['DHL'] = {
              totalWeight,
              totalPrice,
              totalCompensation,
              individualWeight,
              individualPrice,
              individualCompensation,
            };
          }
        },
      );
      return limits;
    },
  },
  data() {
    return {
      icons: [
        {
          courier: 1,
          src: 'fedex_icon.svg',
          color: null,
          size: 48,
          courierName: 'fedex',
          name: 'FedEx',
          totalWeight: 0,
          totalPrice: 0,
          totalInsurance: 0,
        },
        {
          courier: 2,
          src: 'ups_icon.svg',
          color: null,
          size: 32,
          courierName: 'ups',
          name: 'UPS',
          totalWeight: 0,
          totalPrice: 0,
          totalInsurance: 0,
        },
        {
          courier: 3,
          src: 'dhl_icon.svg',
          color: 'orange',
          size: 28,
          courierName: 'dhl',
          name: 'DHL',
          totalWeight: 0,
          totalPrice: 0,
          totalInsurance: 0,
        },
      ],
      showDialog: false,
      showCourierCancelModal: false,
      showHardCancelModal: false,
      showDangerStatusChangeModal: false,
      showShipmentConfirmModal: false,
      showShipmentCheckModal: false,
      showReviewModal: false,
      info: null,
      selectedShipments: [],
      reservationNumber: null,
      showReservationModal: false,
      showCslMatchingModal: false,
      showCslMatchingHitModal: false,
      showCslMatchingNoHitModal: false,
      uploadShipmentDocumentsModal: null,
      uploadOperatorDocumentsModal: null,
      sendWWEFModal: false,
      sendWWEFCancelModal: false,
      uploadingRow: null,
      role: false,
      confirmText: '',
      dangerMessage: '',
      methodFlag: 1,
      sendShippingSeqNumber: '',
      submitData: { shukkayoteiDate: this.shukkayoteiDate },
      cslMatchingTarget: { memberName: true, accountHolderCompanyName: true, shipToCompanyName: true, ceoName: false },
      cslMatchingReqId: '',
      intervalId: null,
      filteredAnkens: null,
      sendWWEFMailResult: null,
      sendWWEFCancelMailResult: null,
      baseAddressList: null,
    };
  },
  async created() {
    this.role = await this.getRole({ page: this.path.SHUKKA_SHORUI_SAKUSEI, authority: this.user.authority });
    await this.initialize();
    this.baseAddressList = await this.apiGetBaseAddress();
  },
  updated() {
    this.icons.forEach((icon) => {
      if (icon.courier == 1) {
        icon.totalWeight = this.shipmentTotalsByCourier?.fedex?.totalWeight ?? 0;
        icon.totalPrice = this.shipmentTotalsByCourier?.fedex?.totalPrice ?? 0;
        icon.totalInsurance = this.shipmentTotalsByCourier?.fedex?.totalInsurance ?? 0;
      }
      if (icon.courier == 2) {
        icon.totalWeight = this.shipmentTotalsByCourier?.ups?.totalWeight ?? 0;
        icon.totalPrice = this.shipmentTotalsByCourier?.ups?.totalPrice ?? 0;
        icon.totalInsurance = this.shipmentTotalsByCourier?.ups?.totalInsurance ?? 0;
      }
      if (icon.courier == 3) {
        icon.totalWeight = this.shipmentTotalsByCourier?.dhl?.totalWeight ?? 0;
        icon.totalPrice = this.shipmentTotalsByCourier?.dhl?.totalPrice ?? 0;
        icon.totalInsurance = this.shipmentTotalsByCourier?.dhl?.totalInsurance ?? 0;
      }
    });
  },
  methods: {
    ...mapActions({
      apiListCourier: 'api/listCourier',
      apiGetPackingsReadyForShipment: 'api/getPackingsReadyForShipment',
      apiGetCountryList: 'api/getConstantList',
      setMode: 'ui/setMode',
      setSuccess: 'ui/setSuccess',
      apiUpdatePacking: 'api/updateEachPackingInfo',
      apiRevertShipment: 'api/revertShipment',
      apiAddReservationNumber: 'api/addReservationNumber',
      apiCreateShipmentFedEx: 'api/createShipmentFedex',
      apiRetreiveShipmentFedEx: 'api/retreiveShipmentFedex',
      apiCancelShipmentFedEx: 'api/cancelShipmentFedex',
      apiCreateShipmentUPS: 'api/createShipmentUPS',
      apiCancelShipmentUPS: 'api/cancelShipmentUPS',
      apiCreateShipmentDHL: 'api/createShipmentDHL',
      apiCancelShipmentDHL: 'api/cancelShipmentDHL',
      apiHardCancelShipment: 'api/hardCancelShipment',
      apiUpdateShipTo: 'api/updateShipTo',
      apiUpdateShipToTempChange: 'api/updateShipToTempChange',
      apiUpdateShipToManualInputs: 'api/updateShipToManualInputs',
      apiCslMatching: 'api/cslMatching',
      apiGetCslMatchingResult: 'api/getCslMatchingResult',
      toggleShowModal: 'ui/toggleShowModal',
      setClickedConfirmFlag: 'ui/setClickedConfirmFlag',
      setClickedCancelFlag: 'ui/setClickedCancelFlag',
      setModalTitle: 'ui/setModalTitle',
      setModalMessage: 'ui/setModalMessage',
      setModalSuccessBtnLabel: 'ui/setModalSuccessBtnLabel',
      setModalConfirmBtnLabel: 'ui/setModalConfirmBtnLabel',
      setModalCancelBtnLabel: 'ui/setModalCancelBtnLabel',
      resetModalContents: 'ui/resetModalContents',
      downloadMergedExcels: 'api/downloadMergedExcels',
      downloadPrintExcel: 'api/downloadPrintExcel',
      downloadFile: 'api/downloadFile',
      getRole: 'common/getRole',
      apiGetExchangeRate: 'api/getExchangeRate',
      apiGetBaseAddress: 'api/getBaseAddress',
      apiUpdatePickUpAddress: 'api/updatePickUpAddress',
      apiGetWwefSentFlag: 'api/getWwefSentFlag',
    }),
    ...mapMutations({
      setSubmitData: 'shukkaShoruiSakusei/setSubmitData',
      setProgress: 'shukkaShoruiSakusei/setProgress',
      setShippingDate: 'shukkaShoruiSakusei/setShippingDate',
    }),
    async initialize() {
      this.submitData = this.searchConditions;
      await Promise.all([this.apiGetCountryList(), this.apiListCourier()]);
    },
    editPacking(packing) {
      packing.editing = !packing.editing;
      packing.newValue.reservation_number = packing.reservation_number;
      packing.newValue.pickup_location_code = packing.pickup_location_code;
      packing.newValue.bikou = packing.bikou_list;
      packing.newValue.double_check = packing.double_check;
      packing.newValue.main_shipping_data_checker = packing.main_shipping_data_checker;
      packing.newValue.csl_matching_confirm_flag = packing.csl_matching_confirm_flag;
      packing.newValue.csl_matching_memo = packing.csl_matching_memo;
    },
    itemClass(item) {
      if (item.editing) {
        return 'highlight-green not-change-hover-color';
      }
      return '';
    },
    /**
     * 地域の制限をクーリエで検索して見つけたらトータルの制限をReturnする
     */
    courierLimitsByRegion(region, _courierId) {
      const found = this.list.find(({ countryCode, courierId }) => countryCode == region && +courierId == +_courierId);
      return found ?? { totalWeight: 0, totalPrice: 0, totalCompensation: 0 };
    },
    /**
     * 国の制限をクーリエで検索して見つけたらトータルの制限をReturnする
     */
    courierLimitsByCountries(_countryName, _courierId) {
      const found = this.list.find(
        ({ countryName, courierId }) => countryName == _countryName && +courierId == +_courierId,
      );
      return found ?? { totalWeight: 0, totalPrice: 0, totalCompensation: 0 };
    },
    rowSelected(selectedRows) {
      this.selectedShipments = selectedRows;
    },
    async revertShipping() {
      const wwefSentFlag = await this.apiGetWwefSentFlag(this.selectedShippingSeqNumbers);
      if (!wwefSentFlag) {
        const seq = this.selectedShipments.map(({ shipping_seq_number }) => shipping_seq_number);
        await this.apiRevertShipment(seq);
        await this.initialize();
        await this.apiGetPackingsReadyForShipment(this.submitData);
      }
    },
    async addReservationNumber(_, shippingSeqForReservationNos = null) {
      const formData = [
        shippingSeqForReservationNos ? shippingSeqForReservationNos : this.selectedShippingSeqNumbers,
        this.reservationNumber,
        this.user ? this.user.userName : 'SYSTEM',
      ];
      this.showReservationModal = false;
      await this.apiAddReservationNumber(formData);
      await this.initialize();
      await this.apiGetPackingsReadyForShipment(this.submitData);
      this.$refs.table.resetSelected();
    },
    async cslMatching() {
      this.requestId = this.user.userId + '-' + new Date().getTime();
      const selectedMatters = this.packingsReadyForShipment.filter((x) =>
        this.selectedShippingSeqNumbers.includes(x.shipping_seq_number),
      );
      const matchingPayload = {
        requestId: this.requestId,
        selectedMatters,
        target: this.cslMatchingTarget,
        executePage: executePage.CREATE_SHIPPING_DOC,
      };
      await this.apiCslMatching(matchingPayload);
      const getResultPayload = { requestId: this.requestId, csvFlag: false };

      this.intervalId = setInterval(async () => {
        await this.apiGetCslMatchingResult(getResultPayload);
        if (this.cslMatchingResult.length > 0) {
          clearInterval(this.intervalId);

          let hitFlag = false;
          this.cslMatchingResult.forEach((result) => {
            if (
              result.hit_member_name ||
              result.hit_account_holder_company_name ||
              result.hit_ship_to_company_name ||
              result.hit_ceo_name
            ) {
              hitFlag = true;
            }
          });

          if (hitFlag) {
            this.showCslMatchingHitModal = true;
          } else {
            this.showCslMatchingNoHitModal = true;
          }

          this.apiGetPackingsReadyForShipment(this.submitData);
        }
      }, 3000);
    },
    closeCslMatchingModal() {
      this.showCslMatchingModal = false;
      this.cslMatchingTarget = {
        memberName: true,
        accountHolderCompanyName: true,
        shipToCompanyName: true,
        ceoName: false,
      };
      clearInterval(this.intervalId);
      this.intervalId = null;
    },
    closeCslMatchingResultModal() {
      this.showCslMatchingHitModal = false;
      this.showCslMatchingNoHitModal = false;
      this.showCslMatchingModal = false;
      this.cslMatchingTarget = {
        memberName: true,
        accountHolderCompanyName: true,
        shipToCompanyName: true,
        ceoName: false,
      };
      this.intervalId = null;
    },
    async addReservationNumberWithoutOverwrite() {
      const shippingSeqForReservationNos = this.selectedShippingSeqNumbers.filter(
        (x) => this.shippingSeqWithReservationNumber.indexOf(x) === -1,
      );
      await this.addReservationNumber(null, shippingSeqForReservationNos);
    },
    async createShipment(data) {
      const payload = { shippingSeqNumber: data.shipping_seq_number, memberName: data.member_name_en };
      data.courier == 1
        ? await this.apiCreateShipmentFedEx(payload)
        : data.courier == 2
          ? await this.apiCreateShipmentUPS(payload)
          : data.courier == 3
            ? await this.apiCreateShipmentDHL(payload)
            : this.showModal();
      if (data.courier > 0 && data.courier < 4) {
        await this.initialize();
        await this.apiGetPackingsReadyForShipment(this.submitData);
      }
    },
    async retreiveShipment(data) {
      const payload = { shippingSeqNumber: data.shipping_seq_number, memberName: data.member_name_en };
      await this.apiRetreiveShipmentFedEx(payload);
      await this.initialize();
      await this.apiGetPackingsReadyForShipment(this.submitData);
    },
    async cancelShipment(data) {
      const payload = {
        shippingSeqNumber: data.shipping_seq_number,
        trackingNumber: data.tracking_number,
        checkReservationNumber: true,
      };
      let reservationNumExist = false;
      data.courier == 1
        ? await this.apiCancelShipmentFedEx(payload)
        : data.courier == 2
          ? (reservationNumExist = await this.apiCancelShipmentUPS(payload))
          : data.courier == 3
            ? // DHLにはキャンセルapiはないがstatusをキャンセルにしてたことにしたい
              await this.apiCancelShipmentDHL(payload)
            : this.showModal();
      if (data.courier > 0 && data.courier < 4) {
        await this.initialize();
        await this.apiGetPackingsReadyForShipment(this.submitData);
      }
      return reservationNumExist;
    },
    async updatePackingInfo(data) {
      data.editing = false;
      const packing = {
        ...data,
        shipping_bikou_flag: data.newValue.shipping_bikou_flag ?? data.shipping_bikou_flag,
        arms_payment_received_flag: data.newValue.arms_payment_received_flag ?? data.arms_payment_received_flag,
        bikou: data.newValue.bikou,
        shipping_data_checker: data.newValue.shipping_data_checker,
        main_shipping_data_checker: data.newValue.main_shipping_data_checker,
        reservation_number: data.newValue.reservation_number,
        pickup_location_code: data.newValue.pickup_location_code ?? data.pickup_location_code,
        double_check: data.newValue.double_check ?? data.double_check,
      };
      const updates = [
        packing.shipping_seq_number,
        packing.reservation_number,
        packing.bikou,
        packing.shipping_bikou_flag,
        packing.arms_payment_received_flag,
        null,
        null,
        null,
        this.user.userName,
        packing.shipping_data_checker,
        packing.main_shipping_data_checker,
        null,
        packing.double_check,
        packing.newValue.csl_matching_confirm_flag,
        packing.newValue.csl_matching_memo,
        packing.pickup_location_code,
      ];
      await this.apiUpdatePacking(updates);
      await this.initialize();
      await this.apiGetPackingsReadyForShipment(this.submitData);
    },
    async updateStatus(data) {
      data.editing = false;
      const updates = [
        data.shipping_seq_number,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        this.user.userName,
        null,
        null,
        6,
        null,
        null,
        null,
        null,
      ];
      await this.apiUpdatePacking(updates);
      await this.submitForm();
    },
    submitForm() {
      this.apiGetPackingsReadyForShipment(this.submitData);
    },
    async showShipmentModal(info, showChange) {
      await this.apiGetExchangeRate();
      this.showDialog = true;
      this.info = info;
      // 0 -> show shipment address modification
      if (showChange === 0) {
        this.showShipmentConfirmModal = false;
      }
      // 1 -> show confirmation before sending to api
      if (showChange === 1) {
        this.showShipmentConfirmModal = true;
      }
    },
    async handleConfirm(
      sameShipToAndSameShippingFeePayer,
      shipToType,
      manualShipToInputs,
      memberId,
      shippingSeqNumber,
      matterNoList,
      shippingFeePayer,
      shippingFeePayerAcc,
      shippingFeePayerCompanyName,
      taxPayerAccNo,
      taxPayerCompanyName,
      description,
      pickUpBase,
      pickUpCompanyName,
      pickUpCountryName,
      pickUpCountryCode,
      pickUpCityName,
      pickUpPostalCode,
      pickUpAddr1,
      pickUpAddr2,
      pickUpFloor,
      pickUpTel,
      pickUpManagerName,
    ) {
      this.methodFlag = 1;
      this.showReviewModal = false;
      const wwefSentFlag = await this.apiGetWwefSentFlag([shippingSeqNumber]);
      if (wwefSentFlag) return;
      if (sameShipToAndSameShippingFeePayer && shipToType !== 5) {
        // 同じ送付先と同じ送料負担者が選択された場合 do nothing
        // 手動入力(shipTotype=5)は↓の処理
        this.showDialog = false;
        return;
      } else if (shipToType == 5) {
        // 手動入力
        const params = [JSON.stringify([manualShipToInputs]), shippingSeqNumber];
        await this.apiUpdateShipToManualInputs(params);
      } else {
        // 送付先1, 送付先2, 送付先3, 一時変更, 送料負担者変更
        const params = [
          shipToType,
          memberId,
          shippingSeqNumber,
          matterNoList,
          shippingFeePayer,
          shippingFeePayerAcc,
          shippingFeePayerCompanyName,
          taxPayerAccNo,
          taxPayerCompanyName,
          description,
        ];
        await this.apiUpdateShipTo(params);
      }
      const pickUpParams = [
        shippingSeqNumber,
        pickUpBase,
        pickUpCompanyName,
        pickUpCountryName,
        pickUpCountryCode,
        pickUpCityName,
        pickUpPostalCode,
        pickUpAddr1,
        pickUpAddr2,
        pickUpFloor,
        pickUpTel,
        pickUpManagerName,
        this.user.userId,
      ];
      await this.apiUpdatePickUpAddress(pickUpParams);
      this.showDialog = false;
      // テーブルをリフレッシュ/新データに更新
      await this.apiGetPackingsReadyForShipment(this.submitData);
    },

    showShipmentConfirm(data) {
      this.showShipmentConfirmModal = true;
      this.info = data;
    },
    async handleShipmentConfirm(data, manualShipToInputs) {
      this.showDialog = false;
      if (this.methodFlag === 3) {
        await this.updatePackingInfo({
          shipping_seq_number: data.shipping_seq_number,
          newValue: { shipping_data_checker: this.user.userName },
        });
      } else {
        const params = [JSON.stringify([manualShipToInputs]), data.shipping_seq_number];
        await this.apiUpdateShipToManualInputs(params);
        await this.createShipment(data);
      }
      this.showShipmentConfirmModal = false;
      this.showShipmentCheckModal = false;
      this.methodFlag = 1;
    },

    showDangerStatusChangeConfirmModal(info) {
      this.toggleShowModal();
      this.setModalTitle(this.labels.UPDATE_CONFIRM);
      this.setModalMessage(this.messages.UPDATE_CONFIRM);
      this.setModalConfirmBtnLabel(this.labels.BTN_CHANGE);
      this.setMode(this.labels.UPDATE);
      this.info = info;
    },
    showCourierCancelConfirmModal(info) {
      this.showCourierCancelModal = true;
      this.dangerConfirmText = info.shipping_seq_number;
      this.dangerMessage = this.messages.COURIER_SHIPMENT_CANCEL_CONFIRM;
      this.info = info;
    },
    showUpsCancelConfirmModal(info) {
      this.toggleShowModal();
      this.setModalTitle(this.labels.CANCEL_CONFIRM);
      this.setModalMessage(this.messages.UPS_CANCEL_ALL_CONFIRM);
      this.setModalConfirmBtnLabel(this.labels.YES);
      this.setModalCancelBtnLabel(this.labels.NO);
      this.setMode(this.labels.ALL_CANCEL);
      this.info = info;
    },
    showHardCancelConfirmModal(info) {
      this.showHardCancelModal = true;
      this.dangerConfirmText = info.shipping_seq_number;
      this.dangerMessage = this.messages.COURIER_SHIPMENT_HARD_CANCEL_CONFIRM;
      this.info = info;
    },
    async handleCourierCancel() {
      const reservationNumExist = await this.cancelShipment(this.info);
      this.showCourierCancelModal = false;
      if (reservationNumExist) {
        this.showUpsCancelConfirmModal(this.info);
      }
    },
    async handleHardCancel() {
      await this.apiHardCancelShipment([this.info.shipping_seq_number, this.user.userName]);
      this.apiGetPackingsReadyForShipment(this.submitData);
      this.showHardCancelModal = false;
    },
    async handleDangerStatusChangeConfirm() {
      await this.updateStatus(this.info);
      this.setSuccess(true);
      this.setModalTitle('成功');
      this.setModalMessage(this.messages.SHIPPING_DOCUMENT_UPDATE_COMPLETE);
      this.setModalSuccessBtnLabel('閉じる');
    },
    handleClose() {
      this.showDialog = false;
      this.methodFlag = 1;
      this.showCourierCancelModal = false;
      this.showHardCancelModal = false;
      this.showDangerStatusChangeModal = false;
      this.dangerConfirmText = '';
      this.dangerMessage = '';
      this.showReviewModal = false;
      this.showShipmentConfirmModal = false;
      this.showShipmentCheckModal = false;
    },
    showModal() {
      this.toggleShowModal();
      this.setModalTitle('Info');
      this.setModalMessage('No api for this courier');
      this.setModalConfirmBtnLabel('OK');
    },
    checkHitCslMatching(item) {
      return (
        item.csl_hit_member_name ||
        item.csl_hit_account_holder_company_name ||
        item.csl_hit_ship_to_company_name ||
        item.csl_hit_ceo_name
      );
    },
    async upsShipmentModalClose() {
      this.showCourierCancelModal = false;
      this.showDialog = false;
      await this.apiGetPackingsReadyForShipment(this.submitData);
    },
    ankenFilter() {
      this.filteredAnkens = this.packingsReadyForShipment.filter((item) => {
        const baseIds = this.currentBases.map((base) => base.id);
        const res = baseIds.includes(item.base_id);
        return res;
      });
    },
    openSendWWEFModal(item) {
      this.uploadingRow = item;
      this.sendWWEFModal = true;
    },
    openSendWWEFCancelModal(item) {
      this.uploadingRow = item;
      this.sendWWEFCancelModal = true;
    },
    showSentMailSuccessModal() {
      this.toggleShowModal();
      this.setModalTitle(this.labels.MAIL_SENT_SUCCESS);
      this.setModalMessage(this.messages.WWEF_MAIL_SENT_SUCCESS);
      this.setClickedConfirmFlag(false);
      this.setSuccess(true);
      this.setModalSuccessBtnLabel(this.labels.CLOSE);
      this.setMode(this.labels.REGISTER);
    },
    showSentCancelMailSuccessModal() {
      this.toggleShowModal();
      this.setModalTitle(this.labels.CANCEL_MAIL_SENT_SUCCESS);
      this.setModalMessage(this.messages.WWEF_CANCEL_MAIL_SENT_SUCCESS);
      this.setClickedConfirmFlag(false);
      this.setSuccess(true);
      this.setModalSuccessBtnLabel(this.labels.CLOSE);
      this.setMode(this.labels.REGISTER);
    },
  },
  watch: {
    async clickedConfirm(val) {
      this.setClickedConfirmFlag(false);
      if (val) {
        switch (this.mode) {
          case this.labels.UPDATE:
            this.handleDangerStatusChangeConfirm();
            break;
          case this.labels.ALL_CANCEL:
            this.toggleShowModal();
            this.setMode('');
            await this.apiCancelShipmentUPS({
              shippingSeqNumber: this.info.shipping_seq_number,
              trackingNumber: this.info.tracking_number,
              checkReservationNumber: false,
              pickupCancelAllFlag: true,
            });
            break;
          default:
            this.toggleShowModal();
            break;
        }
      }
    },
    async clickedCancel(val) {
      this.setClickedCancelFlag(false);
      if (val) {
        switch (this.mode) {
          case this.labels.ALL_CANCEL:
            this.setMode('');
            await this.apiCancelShipmentUPS({
              shippingSeqNumber: this.info.shipping_seq_number,
              trackingNumber: this.info.tracking_number,
              checkReservationNumber: false,
            });
            break;
          default:
            break;
        }
      }
    },
    searchConditions(newVal) {
      this.submitData = newVal;
    },
    showReservationModal(newVal) {
      if (!newVal) this.reservationNumber = null;
    },
    currentBases() {
      this.ankenFilter();
    },
    packingsReadyForShipment(packingsReadyForShipment) {
      if (this.currentBases.length > 0) {
        this.ankenFilter();
      } else {
        this.filteredAnkens = packingsReadyForShipment;
      }
    },
    sendWWEFMailResult() {
      this.showSentMailSuccessModal();
      this.apiGetPackingsReadyForShipment(this.submitData);
    },
    sendWWEFCancelMailResult() {
      this.showSentCancelMailSuccessModal();
      this.apiGetPackingsReadyForShipment(this.submitData);
    },
  },
  beforeDestroy() {
    this.$store.commit('shukkaShoruiSakusei/setPackingsReadyForShipment', []);
  },
};
</script>
<style scoped>
.manager-name-text {
  font-size: xx-small;
}
.reservation-caption {
  font-size: 9px;
  line-height: 1.1;
  white-space: nowrap;
  text-align: center;
}
</style>
